
const inventoryAdjustmentType = {
  INVENTORY_ADJUSTMENTS_TABLE_STATE_SET:
    'INVENTORY_ADJUSTMENTS/TABLE_STATE_SET',
  INVENTORY_ADJUSTMENTS_TABLE_STATE_RESET:
    'INVENTORY_ADJUSTMENTS/TABLE_STATE_RESET',
};
export default inventoryAdjustmentType;
